<!-- Filtros -->
<div class="filters-container" *ngIf="showFilters && !filterMobile()">
    <div class="filter-group">
        <label>Filtrar dimensión</label>
        <div class="filter-dropdown" (click)="toggleDimensionFilter()">
            <span *ngIf="!selectedDimension" style="opacity: 0.6;">Todas las dimensiones</span>
            <span *ngIf="selectedDimension">{{ selectedDimension }}</span>
            <mat-icon>keyboard_arrow_down</mat-icon>
        </div>
        <div *ngIf="dimensionFilterOpen" class="dropdown-menu">
            <div (click)="selectDimension('')">Todas las dimensiones</div>
            <div *ngFor="let dimension of dimensions" (click)="selectDimension(dimension.name)">
                {{ dimension.name }}
            </div>
        </div>
    </div>

    <div class="filter-group">
        <label>Filtrar estado</label>
        <div class="filter-dropdown" (click)="toggleStatusFilter()">
            <span *ngIf="!selectedStatus" style="opacity: 0.6;">Todos los estados</span>
            <span *ngIf="selectedStatus">{{ selectedStatus }}</span>
            <mat-icon>keyboard_arrow_down</mat-icon>
        </div>
        <div *ngIf="statusFilterOpen" class="dropdown-menu">
            <div (click)="selectStatus('')">Todos los estados</div>
            <div (click)="selectStatus('Terminado')">Terminado</div>
            <div (click)="selectStatus('Por Vencer')">Por Vencer</div>
            <div (click)="selectStatus('Atrasado')">Atrasado</div>
            <div (click)="selectStatus('En progreso')">En progreso</div>
        </div>
    </div>

    <div class="filter-group">
        <label>Filtrar Desde</label>
        <div class="date-input-wrapper">
            <input type="text" readonly autocomplete="off" inputmode="none" [value]="filterFromDate"
                [placeholder]="placeholderCalendar" (click)="openModalCalendar('start')" class="date-input">
            <mat-icon class="calendar-icon" (click)="openModalCalendar('start')">calendar_today</mat-icon>
        </div>
    </div>

    <div class="filter-group">
        <label>Filtrar Hasta</label>
        <div class="date-input-wrapper" [ngClass]="!filterFromDate ? 'disabled' : ''">
            <input type="text" readonly autocomplete="off" inputmode="none" [value]="filterToDate"
                [placeholder]="placeholderCalendar" (click)="openModalCalendar('end', filterFromDate)"
                class="date-input">
            <mat-icon class="calendar-icon" (click)="openModalCalendar('end', filterFromDate)">calendar_today</mat-icon>
        </div>
    </div>
</div>

<div class="filters-container" *ngIf="showFilters && filterMobile()">
    <button class="btn-mobile" (click)="openModalFilters()">Filtros</button>
</div>

<!-- Tabla de objetivos -->
<div class="table-container">
    <table class="objectives-table">
        <thead>
            <tr>
                <th class="sortable" (click)="sortBy('name')">
                    <div class="header-content">
                        <span>Nombre</span>
                        <mat-icon class="sort-icon">unfold_more</mat-icon>
                    </div>
                </th>
                <th class="sortable" (click)="sortBy('dimension')">
                    <div class="header-content">
                        <span>Dimensión</span>
                        <mat-icon class="sort-icon">unfold_more</mat-icon>
                    </div>
                </th>
                <th class="sortable" (click)="sortBy('startDate')">
                    <div class="header-content">
                        <span>Fecha inicio</span>
                        <mat-icon class="sort-icon">unfold_more</mat-icon>
                    </div>
                </th>
                <th class="sortable" (click)="sortBy('endDate')">
                    <div class="header-content">
                        <span>Fecha fin</span>
                        <mat-icon class="sort-icon">unfold_more</mat-icon>
                    </div>
                </th>
                <!-- <th class="sortable" (click)="sortBy('updateDate')">
                    Actualización
                    <mat-icon class="sort-icon">unfold_more</mat-icon>
                </th>
                <th class="sortable" (click)="sortBy('updatedBy')">
                    Quien actualizó
                    <mat-icon class="sort-icon">unfold_more</mat-icon>
                </th> -->
                <th class="sortable" (click)="sortBy('status')">
                    <div class="header-content">
                        <span>Estado</span>
                        <mat-icon class="sort-icon">unfold_more</mat-icon>
                    </div>
                </th>
                <th>Acciones</th>
            </tr>
        </thead>
        <tbody>
            <ng-container *ngFor="let objetivo of paginatedData; let i = index">
                <tr (click)="toggleExpand(objetivo, $event)" [class.expanded-row]="expandedElement === objetivo"
                    class="objective-row">
                    <td class="objective-name-cell">{{ truncateWithLineBreak(objetivo.name) }}</td>
                    <td>
                        <div class="dimension-badge">
                            {{ objetivo.dimension.name }}
                        </div>
                    </td>
                    <td>{{ objetivo.start }}</td>
                    <td>{{ objetivo.end }}</td>
                    <!-- <td>{{ objetivo.updatedAt || '13/07/2025' }}</td>
                   <td>
                       <div class="user-badge" 
                            matTooltip="Sin Registro"
                            matTooltipClass="custom-tooltip"
                            matTooltipPosition="above">
                           {{ getInitials('Sin Registro') }}
                       </div>
                   </td> -->
                    <td>
                        <div class="status-badge" [ngClass]="getStatusClass(calculateObjectiveStateByDate(objetivo))">
                            {{ getStatusText(calculateObjectiveStateByDate(objetivo)) }}
                        </div>
                    </td>
                    <td>
                        <div class="action-buttons">
                            <button class="action-btn view-btn" (click)="verObjetivo(objetivo)" title="Ver">
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                                    <circle cx="12" cy="12" r="3"></circle>
                                </svg>
                            </button>
                            <button class="action-btn edit-btn"
                                [disabled]="calculateObjectiveStateByDate(objetivo) === 'Eliminado'"
                                [class.disabled]="calculateObjectiveStateByDate(objetivo) === 'Eliminado'"
                                (click)="calculateObjectiveStateByDate(objetivo) !== 'Eliminado' && editarObjetivo(objetivo)"
                                title="Editar">
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                    <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path>
                                </svg>
                            </button>
                            <button class="action-btn delete-btn"
                                [disabled]="calculateObjectiveStateByDate(objetivo) === 'Eliminado'"
                                [class.disabled]="calculateObjectiveStateByDate(objetivo) === 'Eliminado'"
                                (click)="calculateObjectiveStateByDate(objetivo) !== 'Eliminado' && eliminarObjetivo(objetivo._id)"
                                title="Eliminar">
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                    <polyline points="3,6 5,6 21,6"></polyline>
                                    <path
                                        d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2">
                                    </path>
                                    <line x1="10" y1="11" x2="10" y2="17"></line>
                                    <line x1="14" y1="11" x2="14" y2="17"></line>
                                </svg>
                            </button>
                        </div>
                    </td>
                </tr>

                <!-- Fila expandida para mostrar actividades -->
                <tr *ngIf="expandedElement === objetivo" class="activities-row">
                    <td colspan="8">
                        <div class="activities-container">
                            <h4>Actividades del objetivo: {{ truncate(objetivo.name) }}</h4>
                            <table class="activities-table">
                                <thead>
                                    <tr>
                                        <th>Actividades</th>
                                        <th>Descripción</th>
                                        <th>Inicio</th>
                                        <th>Fin</th>
                                        <th>Estado</th>
                                        <th>Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let activity of objetivo.activities">
                                        <td>{{ truncateWithLineBreak(activity.name) }}</td>
                                        <td>{{ truncateWithLineBreak(activity.description || 'Sin descripción') }}</td>
                                        <td>{{ activity.start }}</td>
                                        <td>{{ activity.end }}</td>
                                        <td class="activity-status-cell">
                                            <div class="activity-status-dropdown"
                                                [class.disabled]="calculateObjectiveStateByDate(objetivo) === 'Eliminado'"
                                                (click)="calculateObjectiveStateByDate(objetivo) !== 'Eliminado' && toggleActivityStatusDropdown(objetivo, activity, $event)">
                                                <div class="activity-status-badge"
                                                    [ngClass]="getActivityStatusClass(activity.state)">
                                                    {{ getActivityStatusText(activity.state) }}
                                                </div>
                                                <mat-icon class="dropdown-icon"
                                                    [style.opacity]="calculateObjectiveStateByDate(objetivo) === 'Eliminado' ? '0.3' : '1'">
                                                    keyboard_arrow_down
                                                </mat-icon>
                                            </div>
                                            <div *ngIf="activityStateDropdownOpenFor === activity && activityObjectiveDropdownOpenFor === objetivo && calculateObjectiveStateByDate(objetivo) !== 'Eliminado'"
                                                class="activity-status-dropdown-menu">
                                                <div (click)="changeActivityState(objetivo, activity, 'Nuevo')">Nuevo
                                                </div>
                                                <div (click)="changeActivityState(objetivo, activity, 'Empezado')">
                                                    Empezado</div>
                                                <div (click)="changeActivityState(objetivo, activity, 'Pendiente')">
                                                    Pendiente</div>
                                                <!-- <div (click)="changeActivityState(objetivo, activity, 'Terminado')">Terminado</div> -->
                                            </div>
                                        </td>
                                        <td>
                                            <div class="activity-actions">
                                                <button class="complete-btn"
                                                    [disabled]="calculateObjectiveStateByDate(objetivo) === 'Eliminado'"
                                                    [class.disabled]="calculateObjectiveStateByDate(objetivo) === 'Eliminado'"
                                                    (click)="calculateObjectiveStateByDate(objetivo) !== 'Eliminado' && completeActivity(objetivo, activity)"
                                                    *ngIf="activity.state !== STATES_OBJECTIVES.Terminado.name">
                                                    Completar
                                                </button>
                                                <button class="edit-btn"
                                                    [disabled]="calculateObjectiveStateByDate(objetivo) === 'Eliminado'"
                                                    [class.disabled]="calculateObjectiveStateByDate(objetivo) === 'Eliminado'"
                                                    (click)="calculateObjectiveStateByDate(objetivo) !== 'Eliminado' && editarActividad(objetivo, activity)">
                                                    Editar
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr *ngIf="objetivo.activities.length === 0">
                                        <td colspan="6" class="no-activities">
                                            No hay actividades registradas para este objetivo.
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </td>
                </tr>
            </ng-container>
        </tbody>
        <tr *ngIf="paginatedData.length === 0">
            <td colspan="8" class="no-data-cell">
                Tus objetivos te esperan. Cada acción cuenta para acercarte a tu propósito. Revísalos y sigue avanzando.
            </td>
        </tr>
    </table>
</div>

<!-- Paginación -->
<div class="pagination-container" *ngIf="totalPages > 1">
    <div class="pagination-info">
        <button class="pagination-btn" [disabled]="currentPage === 1" (click)="previousPage()">
            <mat-icon>chevron_left</mat-icon>
        </button>
        <div class="page-numbers">
            <!-- Primera página siempre visible si hay más de 1 página -->
            <button *ngIf="totalPages > 1" class="page-btn" [class.active]="currentPage === 1" (click)="goToPage(1)">
                1
            </button>

            <!-- Puntos suspensivos antes si la página actual está lejos del inicio -->
            <span *ngIf="currentPage > 3 && totalPages > 5" class="page-dots">...</span>

            <!-- Páginas alrededor de la página actual -->
            <ng-container *ngFor="let page of getVisiblePages()">
                <button *ngIf="page !== 1 && page !== totalPages" class="page-btn" [class.active]="currentPage === page"
                    (click)="goToPage(page)">
                    {{ page }}
                </button>
            </ng-container>

            <!-- Puntos suspensivos después si la página actual está lejos del final -->
            <span *ngIf="currentPage < totalPages - 2 && totalPages > 5" class="page-dots">...</span>

            <!-- Última página siempre visible si hay más de 1 página y no es la primera -->
            <button *ngIf="totalPages > 1 && totalPages !== 1" class="page-btn"
                [class.active]="currentPage === totalPages" (click)="goToPage(totalPages)">
                {{ totalPages }}
            </button>
        </div>
        <button class="pagination-btn" [disabled]="currentPage === totalPages" (click)="nextPage()">
            <mat-icon>chevron_right</mat-icon>
        </button>
    </div>

    <div class="results-info">
        Mostrando {{ getDisplayedItemsText() }} de {{ totalItems }} resultados
    </div>

    <div class="items-per-page">
        <span>Mostrar</span>
        <select [(ngModel)]="itemsPerPage" (change)="onItemsPerPageChange()">
            <option value="10">10</option>
            <option value="25">25</option>
            <option value="50">50</option>
        </select>
    </div>
</div>

<!-- Overlay para cerrar dropdowns -->
<div *ngIf="dimensionFilterOpen || statusFilterOpen || activityStateDropdownOpenFor" class="overlay"
    (click)="closeAllDropdowns()">
</div>

<!-- Modal de evidencia -->
<div *ngIf="showEvidenceModal" class="evidence-modal-overlay">
    <div class="evidence-modal" (click)="$event.stopPropagation()">
        <div class="evidence-modal-header">
            <h3>Adjuntar Evidencia</h3>
            <button class="close-button" (click)="closeEvidenceModal()">
                <mat-icon>close</mat-icon>
            </button>
        </div>

        <div class="evidence-modal-body">
            <p class="evidence-description">
                Para completar la actividad "<strong>{{ currentActivity?.name }}</strong>"
                es necesario adjuntar una evidencia (imagen o PDF).
            </p>

            <div class="file-upload-area">
                <input type="file" #evidenceInput accept="image/*,application/pdf,.pdf"
                    (change)="onEvidenceFileSelected($event)" style="display: none;">

                <div class="upload-placeholder" (click)="evidenceInput.click()" [class.has-file]="evidenceFile">

                    <div *ngIf="!evidenceFile" class="placeholder-content">
                        <mat-icon class="upload-icon">attach_file</mat-icon>
                        <p>Haz clic para adjuntar evidencia</p>
                        <span>Imagen (JPG, PNG, GIF) o PDF</span>
                    </div>

                    <div *ngIf="evidenceFile" class="file-preview">
                        <!-- Preview para imágenes -->
                        <div *ngIf="evidencePreview && getFileType(evidencePreview) === 'image'" class="image-preview">
                            <div class="image-container">
                                <img [src]="evidencePreview" alt="Vista previa de imagen" />
                            </div>
                            <div class="file-info">
                                <p class="file-name">{{ evidenceFileName }}</p>
                                <div class="file-actions">
                                    <button class="change-file-btn"
                                        (click)="evidenceInput.click(); $event.stopPropagation()">
                                        <mat-icon>edit</mat-icon>
                                        Cambiar archivo
                                    </button>
                                </div>
                            </div>
                        </div>

                        <!-- Preview para PDF -->
                        <div *ngIf="evidencePreview && getFileType(evidencePreview) === 'pdf'" class="pdf-preview">
                            <div class="pdf-icon-container">
                                <mat-icon class="pdf-icon">picture_as_pdf</mat-icon>
                                <span class="pdf-label">Archivo PDF</span>
                            </div>
                            <div class="file-info">
                                <p class="file-name">{{ evidenceFileName }}</p>
                                <div class="file-actions">
                                    <button class="change-file-btn"
                                        (click)="evidenceInput.click(); $event.stopPropagation()">
                                        <mat-icon>edit</mat-icon>
                                        Cambiar archivo
                                    </button>
                                    <button class="download-file-btn"
                                        (click)="downloadEvidenceFile(); $event.stopPropagation()">
                                        <mat-icon>download</mat-icon>
                                        Descargar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="evidence-modal-footer">
            <button class="cancel-btn" (click)="closeEvidenceModal()" [disabled]="isUploading">
                Cancelar
            </button>
            <button class="complete-btn" (click)="confirmEvidenceAndComplete()"
                [disabled]="!evidenceFile || isUploading">
                <span *ngIf="!isUploading">Completar Actividad</span>
                <span *ngIf="isUploading">Guardando...</span>
            </button>
        </div>
    </div>
</div>

<!-- Modal de confirmación de eliminación -->
<div class="modal-overlay" *ngIf="mostrarModalConfirmacionEliminacion" (click)="cerrarModalConfirmacionEliminacion()">
    <div class="modal-content delete-confirmation-modal" (click)="$event.stopPropagation()">
        <div class="modal-header">
            <div class="warning-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
                    <path d="M24 4L44 40H4L24 4Z" fill="#FF6B6B" stroke="#FF6B6B" stroke-width="2" />
                    <path d="M24 20V28" stroke="white" stroke-width="3" stroke-linecap="round" />
                    <circle cx="24" cy="36" r="2" fill="white" />
                </svg>
            </div>
            <h2 class="modal-title">Confirmar eliminación</h2>
            <p class="modal-description">
                ¿Estás seguro de que deseas eliminar el objetivo
                <strong>"{{ objetivoAEliminar?.name }}"</strong>?
            </p>
            <p class="modal-warning">
                ⚠️ Esta acción no se puede deshacer y eliminará todas las actividades asociadas.
            </p>
        </div>
        <div class="modal-actions">
            <button class="btn-cancel" (click)="cerrarModalConfirmacionEliminacion()">
                Cancelar
            </button>
            <button class="btn-delete" (click)="confirmarEliminacionObjetivo()">
                Eliminar
            </button>
        </div>
    </div>
</div>

<!-- Modal Filtros Mobile -->
<div *ngIf="showModalFilters" class="filters-modal-overlay">
    <div class="filters-modal-content" (click)="$event.stopPropagation()">
        <div class="filters-header"></div> <!-- In case we need a header -->
        <div class="filters-body">
            <div class="filter-group">
                <label>Filtrar dimensión</label>
                <div class="filter-dropdown" (click)="toggleDimensionFilter()">
                    <span *ngIf="!selectedDimension" style="opacity: 0.6;">Todas las dimensiones</span>
                    <span *ngIf="selectedDimension">{{ selectedDimension }}</span>
                    <mat-icon>keyboard_arrow_down</mat-icon>
                </div>
                <div *ngIf="dimensionFilterOpen" class="dropdown-menu">
                    <div (click)="selectDimension('')">Todas las dimensiones</div>
                    <div *ngFor="let dimension of dimensions" (click)="selectDimension(dimension.name)">
                        {{ dimension.name }}
                    </div>
                </div>
            </div>

            <div class="filter-group">
                <label>Filtrar estado</label>
                <div class="filter-dropdown" (click)="toggleStatusFilter()">
                    <span *ngIf="!selectedStatus" style="opacity: 0.6;">Todos los estados</span>
                    <span *ngIf="selectedStatus">{{ selectedStatus }}</span>
                    <mat-icon>keyboard_arrow_down</mat-icon>
                </div>
                <div *ngIf="statusFilterOpen" class="dropdown-menu">
                    <div (click)="selectStatus('')">Todos los estados</div>
                    <div (click)="selectStatus('Terminado')">Terminado</div>
                    <div (click)="selectStatus('Por Vencer')">Por Vencer</div>
                    <div (click)="selectStatus('Atrasado')">Atrasado</div>
                    <div (click)="selectStatus('En progreso')">En progreso</div>
                </div>
            </div>

            <div class="filter-group">
                <label>Filtrar Desde</label>
                <div class="date-input-wrapper">
                    <input type="text" readonly autocomplete="off" inputmode="none" [value]="filterFromDate"
                        [placeholder]="placeholderCalendar" (click)="openModalCalendar('start')" class="date-input">
                    <mat-icon class="calendar-icon" (click)="openModalCalendar('start')">calendar_today</mat-icon>
                </div>
            </div>

            <div class="filter-group">
                <label>Filtrar Hasta</label>
                <div class="date-input-wrapper" [ngClass]="!filterFromDate ? 'disabled' : ''">
                    <input type="text" readonly autocomplete="off" inputmode="none" [value]="filterToDate"
                        [placeholder]="placeholderCalendar" (click)="openModalCalendar('end', filterFromDate)"
                        class="date-input">
                    <mat-icon class="calendar-icon" (click)="openModalCalendar('end', filterFromDate)">
                        calendar_today
                    </mat-icon>
                </div>
            </div>
        </div>
        <div class="filters-actions">
            <button class="btn-cancel" (click)="closeModalFilters()">
                Salir
            </button>
            <button class="btn-delete" (click)="confirmModalFilters()">
                Buscar
            </button>
        </div>
    </div>
</div>

<!-- Modal Calendario -->
<div *ngIf="showModalCalendar" class="calendar-modal-overlay">
    <div class="calendar-modal-content" (click)="$event.stopPropagation()">
        <div class="calendar-header"></div>
        <div class="calendar-body">
            <mat-card class="custom-mat-card">
                <mat-calendar class="custom-mat-calendar" [selected]="modalCalendarValue" [minDate]="calendarMinDate"
                    startView="multi-year" (selectedChange)="onSelectedChange($event)">
                </mat-calendar>
            </mat-card>
            <p style="margin-top: 15px;">Fecha Seleccionada: {{ modalCalendarValue | date:'dd/MM/yyyy' }}</p>
        </div>
        <div class="calendar-actions">
            <button class="btn-cancel" (click)="closeModalCalendar()">
                Cancelar
            </button>
            <button class="btn-confirm" [disabled]="modalCalendarValue == null" (click)="confirmModalCalendar()">
                Confirmar
            </button>
        </div>

    </div>
</div>